module.exports = __webpack_public_path__ + "img/昭通市昭阳区中医医院.6653d4dd.png";